/* istanbul ignore file */
import DetailsBlock from './DetailsBlock'
import withLoader from '../withLoader'
import RentalCarContractProcessCompactPlaceholder from '../../ui/RentalCarContractProcessCompactPlaceholder'

export default withLoader(RentalCarContractProcessCompactPlaceholder)(DetailsBlock)
